<app-nav-menu></app-nav-menu>
<button class="btn btn-up" (click)="scrollTop()">
  <em class="fas fa-angle-up"></em>
</button>